export default __webpack_public_path__ + "content/media/31.3ea6b085.jpg";